<template>
  <div>
    <h1 class="page-header">{{ $t('purchaseorder.purchaseorder') }}</h1>
    <ts-loading-banner :loading="waiting">
      <ts-card>
        <ts-card-wrapper>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <label class="col-form-label col-md-1 required">{{
                  $t('purchaseorder.supplier')
                }}</label>
                <div class="col-md-3">
                  <select
                    v-model="model.supplier_id"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('supplier_id') }"
                  >
                    <option value="">{{ $t('select') }}</option>
                    <option
                      v-for="(supplier, index) in suppliers"
                      :key="index"
                      :value="supplier.supplier_id"
                    >
                      {{ supplier.supplier_name_en }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('supplier_id')">
                    {{ errors.first('supplier_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <label class="col-form-label col-md-1 required">{{
                  $t('purchaseorder.date')
                }}</label>
                <div class="col-md-3">
                  <ts-date-picker-input
                    v-model="model.po_date"
                  ></ts-date-picker-input>
                  <div class="validate" v-if="errors.has('po_date')">
                    {{ errors.first('po_date') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <table class="table ui-table table-hover">
                <thead>
                  <tr>
                    <th style="width:20%">{{ $t('purchaseorder.barcode') }}</th>
                    <th>{{ $t('purchaseorder.producte') }}</th>
                    <th style="width:15%">{{ $t('purchaseorder.uom') }}</th>
                    <th style="width:15%" class="text-center">
                      {{ $t('purchaseorder.quantity') }}
                    </th>
                    <th style="width: 2%" class="text-center">
                      <a href="#" class="text-primary">
                        <i
                          class="fa fa-plus"
                          @click.prevent="addNewRow"
                        ></i>
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in model.sub_item_list" :key="index">
                    <td>
                      <select
                        class="form-control only-border-bottom"
                        v-model="item.product_id"
                        @change="barcodeChange(item)"
                      >
                        <option value="">{{ $t('select') }}</option>
                        <option
                          v-for="(product, index) in products"
                          :key="index"
                          :value="product.product_id"
                        >
                          {{ product.barcode }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <select
                        class="form-control only-border-bottom"
                        :class="{
                          'is-invalid': errors.has(
                            'sub_item_list.' + index + '.product_id'
                          )
                        }"
                        v-model="item.product_id"
                        @change="productChange(item)"
                      >
                        <option value="">{{ $t('select') }}</option>
                        <option
                          v-for="(product, index) in products"
                          :key="index"
                          :value="product.product_id"
                        >
                          {{ product.product_name_en }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="
                          errors.has('sub_item_list.' + index + '.product_id')
                        "
                      >
                        {{
                          errors.first('sub_item_list.' + index + '.product_id')
                        }}
                      </div>
                    </td>
                    <td>
                      <select
                        class="form-control only-border-bottom"
                        :class="{
                          'is-invalid': errors.has(
                            'sub_item_list.' + index + '.uom_id'
                          )
                        }"
                        v-model="item.uom_id"
                      >
                        <option value="">{{ $t('select') }}</option>
                        <option
                          v-for="(uom, index) in uomGetter(item)"
                          :key="index"
                          :value="uom.uom_id"
                          >{{ uom.uom_name_en }}</option
                        >
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('sub_item_list.' + index + '.uom_id')"
                      >
                        {{ errors.first('sub_item_list.' + index + '.uom_id') }}
                      </div>
                    </td>
                    <td>
                      <input
                        type="number"
                        v-model="item.qty"
                        class="form-control only-border-bottom"
                        :class="{
                          'is-invalid': errors.has(
                            'sub_item_list.' + index + '.qty'
                          )
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('sub_item_list.' + index + '.qty')"
                      >
                        {{ errors.first('sub_item_list.' + index + '.qty') }}
                      </div>
                    </td>
                    <td>
                      <a href="#" class="text-danger" @click="removeRow(item)">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-11"></div>
            <div class="col-md-1 text-right ts-whitespace-no-wrap">
              <ts-checkbox v-model="model.preview">{{
                $t('purchaseorder.previewPdfFile')
              }}</ts-checkbox>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12 text-right">
              <ts-button
                class="btn-primary mr-2"
                @click.prevent="update"
                :waiting="waiting"
                >{{ $t('update') }}</ts-button
              >
              <ts-button
                class="btn-default"
                @click="$router.push({ name: 'purchase-order' })"
                >{{ $t('cancel') }}</ts-button
              >
            </div>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import PreviewPDF from './component/preview-pdf.vue'

export default {
  name: 'purchase-order-edit',
  data() {
    return {
      model: {
        po_id: '',
        supplier_id: '',
        preview: true,
        po_date: moment().format('DD-MM-YYYY'),
        sub_item_list: []
      },
      errors: new Errors(),
      waiting: false,
      newRow: {
        po_detail_id: 0,
        barcode: '',
        product_id: '',
        qty: 1,
        uom_id: ''
      }
    }
  },
  created() {
    this.fetDataBeforeCreate()
  },
  computed: {
    ...mapState('purchaseOrder', ['suppliers', 'products', 'edit_data']),
    ...mapGetters('purchaseOrder', ['uomGetter'])
  },
  methods: {
    async fetDataBeforeCreate() {
      this.waiting = true
      await this.$store.dispatch('purchaseOrder/dataBeforeCreate')
      await this.setEditData()
      this.waiting = false
    },
    addNewRow() {
      this.model.sub_item_list.push(_.clone(this.newRow))
    },
    removeRow(item) {
      this.model.sub_item_list.splice(this.model.sub_item_list.indexOf(item), 1)
    },
    barcodeChange(item) {
      if (!item.barcode) {
        item.product_id = ''
        return
      }
      item.uom_id = ''
      let result = this.products.filter(p => p.barcode == item.barcode)
      item.product_id = result[0].product_id
      item.uom_id = result[0].sale_code[0].uom_id
    },
    productChange(item) {
      if (!item.product_id) {
        item.product_id = ''
        return
      }
      item.uom_id = ''
      let result = this.products.filter(p => p.product_id == item.product_id)
      item.barcode = result[0].barcode
      item.uom_id = result[0].sale_code[0].uom_id
    },
    async setEditData() {
      await this.$store.dispatch('purchaseOrder/find', this.$route.params.id)
      this.model.sub_item_list = [];
      if (this.edit_data && Object.keys(this.edit_data).length) {
      this.model.po_id = this.edit_data.po_id || ''
      this.model.supplier_id = this.edit_data.supplier_id || ''
      this.model.po_date = this.edit_data.po_date || moment().format('DD-MM-YYYY')
      this.model.preview = true
      this.model.sub_item_list = Array.isArray(this.edit_data.purchase_order_details)
        ? this.edit_data.purchase_order_details.map(detail => ({ 
          po_detail_id: 0,
          product_id: parseInt(detail.product_id),
          qty: detail.qty,
          uom_id: detail.uom_id

         }))
        : []
      }
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('purchaseOrder/update', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          if (this.model.preview) {
            this.$modal.show(
              PreviewPDF,
              {
                url: response.url
              },
              {
                height: 'auto',
                width: '50%',
                scrollable: true,
                draggable: '.form-header',
                clickToClose: false
              },
              {
                'before-close': this.clearInput
              }
            )
          } else {
            this.$router.push({ name: 'purchase-order' })
          }
        })
        .catch(error => {
          this.waiting = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseOrder/RESET_STATE')
    next()
  }
}
</script>
<style lang="css" scoped>
table td {
	vertical-align : middle;
}
.only-border-bottom {
	border-top: none;
	border-left: none;
	border-right: none;
	outline: none;
}
.table > tbody > tr > td{
	padding-top: 5px !important;
	padding-bottom: 5px !important;
	border: none !important
}
</style>
